import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { App } from "antd";
import { Error } from "@triare/auth-redux/dist/saga/common";
import { AlertProps } from "antd/es/alert";
import { AxiosError } from "axios";
import { RootState } from "../../../../../../../store";
import { actions, moduleName } from "../../../../../../../store/auth";
import { getMessageInError } from "../../../../../../../hooks/fetch";

export interface AlertErrorProps extends AlertProps {
  disable?: boolean;
  error?: AxiosError<Error> | null;
}

/**
 * A failed login is reported the way every other failure in the app is: the
 * message toast from App.useApp(), the same one useMessageError raises for the
 * fetch layer. Like that hook, it clears the error once it has been shown, so a
 * stale one cannot surface again when the screen is mounted anew. It renders
 * nothing itself — the component stays in place so the form does not have to
 * know where the error goes.
 */
function AlertError({
  error = null,
  disable = false,
}: AlertErrorProps): React.ReactNode {
  const { message } = App.useApp();
  const dispatch = useDispatch();

  useEffect(() => {
    if (disable === false && error) {
      message.error(getMessageInError(error));
      dispatch({ type: actions.signInErrorClear.toString() });
    }
  }, [error, disable]);

  return null;
}

export default connect((state: RootState) => ({
  error: state[moduleName].signIn.error,
}))(AlertError);
